import { createUseStyles } from "react-jss";

const DESKTOP_DIMENSIONS = 376;
const MOBILE_VIEW_GAP = 16;
const DESKTOP_VIEW_GAP = 64;

export default createUseStyles({
    container: {
        position: "relative",
        width: ({ isMobileView }) => (isMobileView ? "100%" : "auto"),
        display: "flex",
        flexDirection: "column",
        gap:({isMobileView, isAboveChoiceNavigation})=> (isMobileView || !isAboveChoiceNavigation) ? "8px" : "16px",
    },
    statementsContainer: {
        width: "100%",
        display: "flex",
        overflowX: "hidden",
        scrollBehavior: "smooth",
        gap: ({ isMobileView }) =>
            isMobileView ? `${MOBILE_VIEW_GAP}px` : `${DESKTOP_VIEW_GAP}px`,
        padding: "8px 0px",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        "& > div .lottie-gesture": {
            width: "61px",
            height: "30px",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)"
        },
    },
    statement: {
        width: ({ statementWidth }) => `${statementWidth}px`,
        color: "#555555",
        textAlign: "center",
        minWidth: ({ isMobileView }) => (isMobileView ? "100%" : ""),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden",
        boxShadow: ({ isActiveItem }) =>
            isActiveItem ? "0px 0px 6px 1px rgba(0, 0, 0, 0.20)" : "",
        justifyContent: ({ justifyContent }) => justifyContent,
        border: "1px solid #ccc",
        borderRadius: ({ theme, statementWidth }) => {
            let calDimension = statementWidth;
            return `${
                theme.ShowStatementBackgroundSettings
                    ? Math.min(
                          theme.CustomBorderValue
                              ? theme.StatementBorderRadius
                              : theme.ChoiceListBackgroundBorderRadius,
                          calDimension / 2,
                      )
                    : ""
            }px`;
        },
        "& .statementTextContent": {
            padding: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1.2",
            opacity: ({ isActiveItem, isShowLottieGesture, imageUrl}) => {
                return (!isActiveItem || (isShowLottieGesture && !imageUrl) ? "0" : "1");
            },
            transition: "opacity 0.3s ease-in",
            width: "100%",
            boxSizing: "border-box",
        },

        "& .statementTextContent:empty": {
            display: "none",
        },
        "& .image-wrapper": {
            display: "flex",
            justifyContent: "center",
            backgroundColor: ({ isActiveItem }) => (!isActiveItem ? "#F2F2F2" : ""),
            width: ({ isMobileView }) => (isMobileView ? "100%" : `${DESKTOP_DIMENSIONS}px`),
            flex: 1,
            "& .image-element": {
                opacity: ({ isActiveItem, isShowLottieGesture }) => {
                    if (isShowLottieGesture) {
                        return "0.2";
                    }else{
                        return (!isActiveItem ? "0" : "1");
                    }
                },
                transition: "opacity 0.3s ease-in",
                borderRadius: ({ theme }) => {
                    if (!theme.ShowStatementBackgroundSettings || !theme.CustomBorderValue) {
                        if (theme.ChoiceListBackgroundBorderRadius === 100) return "20px";
                        if (theme.ChoiceListBackgroundBorderRadius === 15) return "8px";
                    }

                    if (
                        theme.ShowStatementBackgroundSettings &&
                        theme.StatementBackgroundAlpha === 0
                    ) {
                        return `${theme.StatementBorderRadius}px`;
                    }
                    return "";
                },
            },
        },
    },
    choiceAndNavigationContainer: {
        display: "flex",
        flexDirection: "column",
        gap:({ isMobileView })=> isMobileView ? "16px" : "24px",
    },
    navigationButtonsPanel: {
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        margin: "0 auto",
        alignItems: "center",
        minWidth: "192px",
        gap: "16px",
        "& .fixedWidth": {
            flex: "0 0 20px",
            display: "flex",
            alignItems: "center",
            width: "16px",
            height: "16px",
            padding: "8px 0px",
            "& svg": {
                width: "16px",
            }
        },
        "& .counter-navigation": {
        minWidth : "110px",
        },
    },
    navigationButton: {
        height: "100%",
        cursor: "pointer",
        color: "#667085"
    },
    bulletNavigationPanel: {
        display: "flex",
        gap: "16px",
        alignItems: "center",
        justifyContent: "center",
        "& .ellipse-item": {
            width: "16px",   
            height: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& div": {
                width: "6px",   
                height: "6px",
                borderRadius: "50%",
                backgroundColor: "#667085",
            }
        },
        "& .bullets-container":{
            display: "flex",
            gap: "8px",
            alignItems: "center",
            maxWidth: "136px",
            overflow: "hidden",
            padding: "3px",
            "& > div":{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& svg": {
                    width: "16px",
                    height: "16px",
                }
            },
            "& .active-answered-item": {
                outline: "2px solid #316AEE",
                display: "flex",
                alignItems: "center",
                borderRadius: "50%",
                "& svg": {
                    width: "16px",
                    height: "16px",
                }
            },
            "& .active-not-answered-item": {
                outline: "3px solid #D0D3DD",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                "& svg": {
                    width: "16px",
                    height: "16px",
                }
            },
            "& .bullet": {
                width: "16px",
                height: "16px",
                backgroundColor: "#D0D3DD",
                borderRadius: "50%",
            },
        },
       
    }
});
